import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class AdminListApprove extends React.Component {

	render() {
		const { content: { hostName, listId, listTitle, logo, siteName } } = this.props;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>Dear {hostName},</div>
					<EmptySpace height={20} />
					<div>
						Great news! Your listing has been verified and approved by the admin. You can now publish it and start receiving reservations from guests.
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}><span style={fontWeightBold}>Listing Details:-</span></div>
					<div style={marginBottom}><span style={fontWeightBold}>ID:</span> {listId}</div>
					<div><span style={fontWeightBold}>Title:</span> {listTitle}</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default AdminListApprove;